module.exports = __webpack_public_path__ + "img/sir_hunt-7e83fe45-1831-4b86-e2db-08d957efb91b.png";